import { motion } from "framer-motion";
import { FaBell } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import DefaultButton from "../buttons/defaultButton";
import { useDispatch, useSelector } from "react-redux";
import { _removeReminder } from "../../../store/slices/user.slice";
import { useNavigate } from "react-router-dom";

const SideReminder = () => {
  const { reminders } = useSelector((state) => state?.user);
  const dispatch = useDispatch();
  // const navigate = useNavigate();

  const handleDismissReminder = (item) => {
    dispatch(_removeReminder(item))
  }

  // const handleClick = () => {
  //   navigate("/reminder")
  // }

  return (
    <>
      {reminders?.map((item, index) => (
        <motion.div
          key={index}
          initial={{ x: 50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 50, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          style={{ top: `${100 + index * 8}px`, right: `${20 + index * 8}px` }}
          className={`fixed z-50`} // Adjust spacing
        >
          <div className="relative min-w-200 w-200 flex items-center gap-2 p-4 bg-white border rounded-md group cursor-pointer hover:shadow-md">
            <div className="text-orange-500 flex items-center text-2xl">
              <FaBell />
            </div>

            <div className="flex flex-col">
              <span className="text-sm font-semibold text-theme">{item?.title || "N/A"}</span>
              <span className="text-xs text-textLight">{item?.description || "N/A"}</span>
            </div>

            <div className="absolute -right-4 -top-4 group-hover:block">
              {index == reminders.length - 1 ?
                <DefaultButton
                  variant="iconButton"
                  classnames={"!rounded-full shadow !bg-white border"}
                  onClick={() => handleDismissReminder(item)}
                  icon={<RxCross2 />}
                /> : null}
            </div>
          </div>
        </motion.div>
      ))}
    </>
  );
};

export default SideReminder;
